const PACK_SUITABLE_FOR_STATUS = {
  ALL_AGES: 'All ages',
  ADULTS: 'Adults',
  YOUNG_ADULTS: 'Young adults (17-20)',
  TEENS: 'Teens (14-17)',
  YOUNG_TEENS: 'Teens (12-14)',
  CHILDREN: 'Children (8-11)',
  YOUNG_CHILDREN: 'Young children',
}

export default PACK_SUITABLE_FOR_STATUS
